import React from "react";
import { Text } from "@mantine/core";
import CustomAnchor from "../../components/mantineCustomComponents/CustomAnchor";

// Function for creating data
export const reportsProducerTableData = (reportsProducerData) => {
  if (!Array.isArray(reportsProducerData)) {
    return [];
  }

  return reportsProducerData.map((item) => ({
    strategyName: (
      <CustomAnchor
        text={item.strategy_name}
        href="#"
        rel="noopener noreferrer"
        componentClasses="link"
      ></CustomAnchor>
    ),
    ofCommits: <Text>{item.of_commits}</Text>,
    firstCommit: <Text>{item.first_commit}</Text>,
    lastCommit: <Text>{item.last_commit}</Text>,
    pressRelease: (
      <>
        {item.strategy_name ? (
          <CustomAnchor
            text="Yes"
            href="#"
            rel="noopener noreferrer"
            componentClasses="link"
          ></CustomAnchor>
        ) : (
          <>No</>
        )}
      </>
    ),
  }));
};

// Function for creating columns
export const reportsProducerTableColumns = () => [
  {
    accessorKey: "strategyName",
    header: "Strategy Name",
    enableSorting: true,
    size: 250,
  },
  {
    accessorKey: "ofCommits",
    header: "# of Commits",
    enableSorting: true,
    size: 100,
  },
  {
    accessorKey: "firstCommit",
    header: "First Commit",
    enableSorting: true,
    size: 100,
  },
  {
    accessorKey: "lastCommit",
    header: "Last Commit",
    enableSorting: true,
    size: 100,
  },
  {
    accessorKey: "pressRelease",
    header: "Press Release",
    enableSorting: true,
    size: 100,
    mantineTableBodyCellProps: {
      align: "center",
    },
  },
];

// Function for configuring the table
export const reportsProducerTableOptions = (columns, data, faIcons, theme) => ({
  columns,
  data,
  icons: faIcons,
  paginationDisplayMode: "pages",
  enableFullScreenToggle: false,
  enableTopToolbar: false,
  enableBottomToolbar: true,
  enableColumnActions: false,
  initialState: { pagination: { pageIndex: 0, pageSize: 20 } },
  withColumnBorders: true,
  mantinePaginationProps: () => ({
    showRowsPerPage: false,
    color: theme.customBackgrounds.table,
    autoContrast: true,
    style: {
      paddingBottom: "1.75em",
    },
  }),
  mantineTableProps: {
    style: {
      border: "none",
      borderCollapse: "collapse",
    },
    className: "html-table-mantine",
  },
  mantinePaperProps: {
    withBorder: false,
    shadow: "none",
  },
  mantineTableBodyCellProps: {
    style: {
      padding: "0.6875em 0.9375em 0.5625em 0.9375em",
      fontSize: "1.142em",
    },
  },
  mantineTableHeadCellProps: {
    style: {
      padding: "0.55em 0.9375em 0.4375em 0.9375em",
      fontSize: "1.142em",
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
  mantineTableBodyRowProps: () => ({
    style: {
      borderBottom: theme.customColors.tableBorder,
    },
  }),
  mantineTableHeadRowProps: () => ({
    style: {
      backgroundColor: theme.customBackgrounds.table,
    },
  }),
});
